__turbopack_context__.v({
  "description": "login-module__TltHoW__description",
  "form": "login-module__TltHoW__form",
  "input": "login-module__TltHoW__input",
  "paper": "login-module__TltHoW__paper",
  "title": "login-module__TltHoW__title",
  "wrapper": "login-module__TltHoW__wrapper",
});
